<mat-sidenav-container class="sidenav-container">
  <mat-sidenav #drawer class="sidenav" fixedInViewport
      [attr.role]="(isHandset$ | async) ? 'dialog' : 'navigation'"
      [mode]="(isHandset$ | async) ? 'over' : 'side'"
      [opened]="(isHandset$ | async) === false">
    <mat-toolbar>Menu - {{ environment.environmentName }}</mat-toolbar>
    <mat-nav-list>
      <a mat-list-item [href]="environment.authUrl">Authentication</a>
      <a mat-list-item [href]="environment.dashboardUrl">Dashboard</a>
      <a mat-list-item [href]="environment.dataMapperUrl">Data Mapper</a>
    </mat-nav-list>
  </mat-sidenav>
  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button
        type="button"
        aria-label="Toggle sidenav"
        mat-icon-button
        (click)="drawer.toggle()"
        *ngIf="isHandset$ | async">
        <mat-icon aria-label="Side nav toggle icon">menu</mat-icon>
      </button>
      <span>PVBid Authentication</span>
    </mat-toolbar>
    <app-login></app-login>
  </mat-sidenav-content>
</mat-sidenav-container>
